import * as React from "react";
// import TradeSource from "./tradeSource";
// import TradingStatus from "./tradingStatus";
import FormModel from "../../viewModel/formModel";
import * as TSInstance from "./instance";
import { connect } from "react-redux";

interface ITSSecondaryLinkageProps {
  tradeSourceData: FormModel;
  tradingStatusData: FormModel;
  CreateForm: any;
}

// 贸易状态二级联动
class TSSecondaryLinkage extends React.Component<
  ITSSecondaryLinkageProps,
  any
> {
  constructor(props: ITSSecondaryLinkageProps) {
    super(props);
  }

  getValue = (model, field) => {
    for (const key in this.props.CreateForm[model]) {
      if (key === field) {
        return this.props.CreateForm[model][key];
      } else {
        continue;
      }
    }
    return null;
  };

  render() {
    // 获取Redux 中的值
    let tradeSourceValue = this.getValue(
      this.props.tradeSourceData.modelName,
      this.props.tradeSourceData.field
    );
    this.props.tradeSourceData.value = tradeSourceValue;

    // 获取保持在Redux中的值
    let tradingStatusValue = this.getValue(
      this.props.tradingStatusData.modelName,
      this.props.tradingStatusData.field
    );
    this.props.tradingStatusData.value = tradingStatusValue;

    return (
      <React.Fragment>
        {TSInstance.getTradeSource(this.props.tradeSourceData)}
        {/* <TradeSource width={this.props.width || 140} /> */}
        <span style={{ marginLeft: 8 }}>
          {TSInstance.getTradingStatus(this.props.tradingStatusData)}
          {/* <TradingStatus width={this.props.width || 140} /> */}
        </span>
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  CreateForm: state.antDemo
});

const mapDispatch = dispatch => {
  return {
    setValue: dispatch.antDemo.setValue
  };
};

export default connect(
  mapState,
  mapDispatch
)(TSSecondaryLinkage);
